(function () {

  /**
   * Disable used pins on input, output widgets
   * @param {Object} pParams Object holding function parameters
   * @param {!ml.Config} pParams.config Machine Logic Conf object
   * @param {!Number} pParams.device Device number
   * @param {!Array[JQuery]} pParams.outputWidgetList A list of JQuery elements that wrap output pins
   * @param {!Array[JQuery]} pParams.inputWidgetList A list of JQuery elements that wrap input pins
   * @returns {Void}
   *
   */
  function disableUsedPins(pParams) {
    if (!pParams.outputWidgetList.includes(null) && !pParams.inputWidgetList.includes(null)) {
      const lOutputMap = pParams.config.mOutputMap;
      const lInputMap = pParams.config.mInputMap;
      const lDeviceIO = pParams.device;
      const lListOfOutputWidgets = pParams.outputWidgetList;
      const lListOfInputWidgets = pParams.inputWidgetList;
      const setPropDisable = function(pKey, pDisable) {
        // Set widget disabled props
        return function(pWidget) {
          const _lSelect = pWidget.getSelect();
          _lSelect.find('option[value="' + pKey + '"]').prop('disabled', pDisable && _lSelect.val() != pKey); // We can select the same value so don't disable this one
        };
      };
      const loopThroughMaps = function(pMap, callback) {
        // loop through object keys
        Object.keys(pMap).forEach(callback);
      };
      const handleDisable = function(pMap, pWidgetList) {
        return function(pKey) {
          pWidgetList.forEach(setPropDisable(pKey, pMap[pKey]));
        };
      };
      loopThroughMaps(lOutputMap[lDeviceIO], handleDisable(lOutputMap[lDeviceIO], lListOfOutputWidgets));
      loopThroughMaps(lInputMap[lDeviceIO], handleDisable(lInputMap[lDeviceIO], lListOfInputWidgets));
    }
  }

  /**
   * Helper to disable control device on a
   * control device IO widget
   * @param {Object} pParams - Parameters to disable devices
   * @param {!ml.Config} pParams.config - Machine Logic configuration object
   * @param {JQuery} pParams.controlModuleWidget - Control Module widget
   * @param {?number} pParams.minAvailablePins - Min available pins to decide if control module is available or not
   * @param {?boolean} pParams.checkInputOutput - Should the method assess input and output maps
   * @param {?string} pParams.checkType - Check output/input map
   * @param {?string} pParams.deviceType - Device type of the input/output object
   * @returns {Void}
   */
  function disableDevices(pParams) {
    if (pParams.controlModuleWidget) {
      const lOutputMap = pParams.config.mOutputMap;
      const lInputMap = pParams.config.mInputMap;
      let lListUnavailableOutputs = [];
      let lListUnavailableInputs = [];
      let lListUnavailableToCheck;
      const MIN_AVAILABLE_PINS = pParams.minAvailablePins || 2;
      const checkAvailability = function (pMinAvailablePins, pMap, pNumberOfPinsOnDevice) {
        return function (memo, pDeviceKey) {
          // count available pins
          const lCheckAvailableNumbers = Object.values(pMap[pDeviceKey]).reduce(function (acc, curr) {
            if (!curr) { acc++; }
            return acc;
          }, 0);
          if (pMinAvailablePins && lCheckAvailableNumbers < pMinAvailablePins) { memo.push(pDeviceKey); }
          else if (pNumberOfPinsOnDevice && (Object.values(pMap[pDeviceKey]).length - lCheckAvailableNumbers) == pNumberOfPinsOnDevice) { memo.push(pDeviceKey); }
          return memo;
        };
      };
        // function to return a list of device ids that are occupied by other device types
      const getIncompatibleDevices = function () {
        const incompatibleDeviceIds = [];
        Object.keys(pParams.config.mDeviceTypeMap).forEach(function(pDevice){
          (pParams.config.mDeviceTypeMap[pDevice] != pParams.deviceType && pParams.config.mDeviceTypeMap[pDevice] != '?') && incompatibleDeviceIds.push(pDevice);
        });
        return incompatibleDeviceIds;
      };
      const setPropDisable = function(pDisable) {
        return function (pDeviceKey) {
          pParams.controlModuleWidget.getSelect().find('option[value="' + pDeviceKey + '"]').prop('disabled', pDisable);
        };
      };
      // Run check
      lListUnavailableOutputs = Object.keys(lOutputMap).reduce(checkAvailability(MIN_AVAILABLE_PINS, lOutputMap, pParams.config.getNumberOfPinsOnDeviceType(pParams.deviceType)), []);
      lListUnavailableInputs = Object.keys(lInputMap).reduce(checkAvailability(MIN_AVAILABLE_PINS, lInputMap, pParams.config.getNumberOfPinsOnDeviceType(pParams.deviceType)), []);
      // Enable all, avoid handling states
      Object.keys(lOutputMap).forEach(setPropDisable(false));
      // If input and output is considered, any of
      // them might disable the device
      if (pParams.checkInputOutput) {
        lListUnavailableInputs.forEach(setPropDisable(true));
        lListUnavailableOutputs.forEach(setPropDisable(true));
      } else if (pParams.checkType && /input/i.test(pParams.checkType)) {
        lListUnavailableToCheck = lListUnavailableInputs;
      } else if (pParams.checkType && /output/i.test(pParams.checkType)) {
        lListUnavailableToCheck = lListUnavailableOutputs;
      }
      // Disable what is needed
      lListUnavailableToCheck && lListUnavailableToCheck.forEach(setPropDisable(true));
      pParams.deviceType && getIncompatibleDevices().forEach(setPropDisable(true));
    }
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    disableUsedPins: disableUsedPins,
    disableDevices: disableDevices,
  };
  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
